import { Directive, effect, ElementRef, HostListener, input, Renderer2 } from '@angular/core';

const LETTER_WIDTH = 4;
const BUFFER = 2;

@Directive({
    selector: 'input[libDynamicFollowSuffix]',
    standalone: true
})
export class DynamicFollowSuffix {
    suffixText = input<string>('', { alias: 'libDynamicFollowSuffix' });

    private suffixEl!: HTMLElement;
    private canvas = document.createElement('canvas');

    constructor(private el: ElementRef, private renderer: Renderer2) {
        effect(() => {
            const inputNativeElement = this.el.nativeElement;

            if (this.suffixText()) {
                this.suffixEl = this.renderer.createElement('span');
                this.suffixEl.innerText = this.suffixText();
                this.renderer.setStyle(inputNativeElement.parentNode, 'position', 'relative');
                this.renderer.appendChild(inputNativeElement.parentNode, this.suffixEl);

                this.updatePosition();
            } else if (this.suffixEl) {
                this.suffixEl.style.display = 'none';
            }
        });
    }

    @HostListener('input')
    onInput() {
        this.updatePosition();
    }

    private updatePosition() {
        const inputNativeElement = this.el.nativeElement;

        if (this.canvas) {
            const context = this.canvas?.getContext('2d');

            if (context && this.suffixEl && this.suffixEl.style) {
                context.font = getComputedStyle(inputNativeElement).font;
                const moveX = (inputNativeElement.value.length * LETTER_WIDTH) + BUFFER;// Add small gap after text
                this.suffixEl.style.top = '50%';
                this.suffixEl.style.position = 'absolute';
                this.suffixEl.style.left = `${moveX}px`;
                this.suffixEl.style.transform = `translate(${moveX}px, -45%)`;
            }
        }
    }
}
